import {
    OpxRoute,
    OpxDeeplinkRoute,
    MEETING_INSIGHTS_ROUTE,
    MY_DAY_ROUTE,
    NOTES_PANE_ROUTE,
    ORG_EXPLORER_ROUTE,
    ROOM_PANEL_ROUTE,
    ADD_CALENDAR_ROUTE,
    PERSONAL_SPACE_ROUTE,
    SHARED_SPACE_ROUTE,
    SHARED_SPACE_CONFIG_ROUTE,
    LOCATION_CARD_ROUTE,
    CREATE_GROUP_ROUTE,
    ADD_MEMBERS_ROUTE,
    EDIT_GROUP_ROUTE,
    DISCOVER_GROUP_ROUTE,
    INBOX_RULES_ROUTE,
    DOWNLOAD_MOBILE_ROUTE,
    DATA_PROVIDER_ROUTE,
    ACTIVITY_FEED_ROUTE,
    YAMMER_ROUTE,
    CREATE_BOOKINGS_CALENDAR_ROUTE,
    CALENDAR_WIDGET_ROUTE,
    TODO_WIDGET_ROUTE,
    LEAVE_GROUP_ROUTE,
} from './routeNames';

/**
 * OPX view names must have identical/matching names
 * to the keys used in OWS' OPX config service
 */

export type OpxViewNames =
    | 'MyDay'
    | 'RoomPanel'
    | 'OrgExplorer'
    | 'MeetingInsights'
    | 'NotesPane'
    | 'CalendarWidget'
    | 'TodoWidget'
    | 'LocationCard'
    | 'CreateGroup'
    | 'AddMembers'
    | 'EditGroup'
    | 'DiscoverGroup'
    | 'Yammer'
    | 'TodoWidget'
    | 'LeaveGroup';

/**
 * OPX DEEPLINK view names must have identical/matching names
 * to the keys used in OWS' OPX config service
 */
export type OpxDeeplinkViewNames =
    | 'AddCalendar'
    | 'MyDay'
    | 'PersonalSpace'
    | 'SharedSpace'
    | 'SharedSpaceConfig'
    | 'RoomPanel'
    | 'MeetingInsights'
    | 'LocationCard'
    | 'CreateGroup'
    | 'AddMembers'
    | 'EditGroup'
    | 'DiscoverGroup'
    | 'InboxRules'
    | 'DownloadMobile'
    | 'DataProvider'
    | 'ActivityFeed'
    | 'OrgExplorer'
    | 'Yammer'
    | 'CreateBookingsCalendar'
    | 'CalendarWidget'
    | 'TodoWidget';

type RouteToViewDefinitionsOpx = { [route in OpxRoute]: OpxViewNames };

export const ROUTE_TO_VIEW_DEFINITIONS_OPX: RouteToViewDefinitionsOpx = {
    [MY_DAY_ROUTE]: 'MyDay',
    [ROOM_PANEL_ROUTE]: 'RoomPanel',
    [ORG_EXPLORER_ROUTE]: 'OrgExplorer',
    [MEETING_INSIGHTS_ROUTE]: 'MeetingInsights',
    [NOTES_PANE_ROUTE]: 'NotesPane',
    [CALENDAR_WIDGET_ROUTE]: 'CalendarWidget',
    [YAMMER_ROUTE]: 'Yammer',
    [TODO_WIDGET_ROUTE]: 'TodoWidget',
    [LOCATION_CARD_ROUTE]: 'LocationCard',
    [CREATE_GROUP_ROUTE]: 'CreateGroup',
    [ADD_MEMBERS_ROUTE]: 'AddMembers',
    [EDIT_GROUP_ROUTE]: 'EditGroup',
    [DISCOVER_GROUP_ROUTE]: 'DiscoverGroup',
    [LEAVE_GROUP_ROUTE]: 'LeaveGroup',
};

type RouteToViewDefinitionsOpxDeeplink = { [route in OpxDeeplinkRoute]: OpxDeeplinkViewNames };

export const ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK: RouteToViewDefinitionsOpxDeeplink = {
    [ADD_CALENDAR_ROUTE]: 'AddCalendar',
    [MY_DAY_ROUTE]: 'MyDay',
    [PERSONAL_SPACE_ROUTE]: 'PersonalSpace',
    [SHARED_SPACE_ROUTE]: 'SharedSpace',
    [SHARED_SPACE_CONFIG_ROUTE]: 'SharedSpaceConfig',
    [ROOM_PANEL_ROUTE]: 'RoomPanel',
    [MEETING_INSIGHTS_ROUTE]: 'MeetingInsights',
    [LOCATION_CARD_ROUTE]: 'LocationCard',
    [CREATE_GROUP_ROUTE]: 'CreateGroup',
    [ADD_MEMBERS_ROUTE]: 'AddMembers',
    [EDIT_GROUP_ROUTE]: 'EditGroup',
    [DISCOVER_GROUP_ROUTE]: 'DiscoverGroup',
    [INBOX_RULES_ROUTE]: 'InboxRules',
    [DOWNLOAD_MOBILE_ROUTE]: 'DownloadMobile',
    [DATA_PROVIDER_ROUTE]: 'DataProvider',
    [ACTIVITY_FEED_ROUTE]: 'ActivityFeed',
    [ORG_EXPLORER_ROUTE]: 'OrgExplorer',
    [YAMMER_ROUTE]: 'Yammer',
    [CREATE_BOOKINGS_CALENDAR_ROUTE]: 'CreateBookingsCalendar',
    [CALENDAR_WIDGET_ROUTE]: 'CalendarWidget',
    [TODO_WIDGET_ROUTE]: 'TodoWidget',
};
